import CONSTANTS from './constants';

const navItems = {
    system: {
        iconClass: 'fa fa-cogs',
        name: {
            vi: 'Quản trị'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.SYSTEM],
        children: [
            {
                url: '/system/sms',
                permissions: [CONSTANTS.USER_FUNCTIONS.SYSTEM],
                vi: 'SMS',
                en: 'User'
            },
            {
                url: '/system/feedback',
                permissions: [CONSTANTS.USER_FUNCTIONS.SYSTEM],
                vi: 'Góp ý',
                en: 'User'
            }
        ]
    },
    userNav: {
        iconClass: 'fa fa-users',
        name: {
            vi: 'Người dùng'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.USER],
        children: [
            {
                url: '/user/group',
                permissions: [CONSTANTS.USER_FUNCTIONS.USER],
                vi: 'Nhóm người dùng',
                en: 'group',
                isDefault: true
            },
            {
                url: '/user/user',
                permissions: [CONSTANTS.USER_FUNCTIONS.USER],
                vi: 'Người dùng',
                en: 'User'
            },
            {
                url: '/user/logs',
                permissions: [CONSTANTS.USER_FUNCTIONS.USER],
                vi: 'Nhật ký hệ thống',
                en: 'User'
            }
        ]
    },
    database: {
        viewName: 'database',
        iconClass: 'fa fa-database',
        name: {
            vi: 'Cơ sở dữ liệu'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
        children: [
            {
                url: '/database/stations',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Trạm',
                en: 'group',
                isDefault: true
            },
            {
                url: '/database/configurations',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Tham số',
                en: 'group'
            },
            {
                url: '/database/categories',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Danh mục',
                en: 'User'
            },
            {
                url: '/database/layers',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATA_LAYER],
                vi: 'Lớp dữ liệu',
                en: 'User'
            },
            {
                url: '/database/files',
                permissions: [CONSTANTS.USER_FUNCTIONS.DATABASE],
                vi: 'Tệp',
                en: 'User'
            }
        ]
    },
    analyzeNav: {
        viewName: 'analyze',
        iconClass: 'fa fa-bar-chart',
        name: {
            vi: 'Phân tích'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.ANALYZE],
        children: [
            {
                url: '/analyze/rain',
                permissions: [CONSTANTS.USER_FUNCTIONS.ANALYZE],
                vi: 'Phân tích trận mưa trong quá khứ',
                en: 'Analyze',
                isDefault: true
            },
            {
                url: '/analyze/flood',
                permissions: [CONSTANTS.USER_FUNCTIONS.ANALYZE],
                vi: 'Phân tích lịch sử lũ',
                en: 'Report'
            },
            {
                url: '/analyze/report',
                permissions: [CONSTANTS.USER_FUNCTIONS.ANALYZE],
                vi: 'Báo cáo',
                en: 'Report'
            },
            // {
            //     url: '/analyze/report-data',
            //     permissions: [CONSTANTS.USER_FUNCTIONS.ANALYZE],
            //     vi: 'Thống kê',
            //     en: 'Report'
            // },
            {
                url: '/analyze/flood-image',
                permissions: [CONSTANTS.USER_FUNCTIONS.ANALYZE],
                vi: 'Ảnh lũ',
                en: 'Image'
            },
            {
                url: '/analyze/sensing-image',
                permissions: [CONSTANTS.USER_FUNCTIONS.ANALYZE],
                vi: 'Ảnh viễn thám',
                en: 'Image'
            }
        ]
    },
    newsNav: {
        viewName: 'news',
        iconClass: 'fa fa-newspaper-o',
        name: {
            vi: 'Tin bài'
        },
        permissions: [CONSTANTS.USER_FUNCTIONS.NEWS],
        children: [
            {
                url: '/news/manage-news',
                permissions: [CONSTANTS.USER_FUNCTIONS.NEWS],
                vi: 'Tin bài',
                en: 'User'
            }
        ]
    }
};

export default navItems;
